import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import MediumTypography from '../../components/formlib/MediumTypography';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import { useContext, useEffect, useState } from 'react';
import { LookUpContext } from '../../context/LookUpContextProvider';
import { OptionType } from '../../utils/type';

interface CancelVisitsProps {
  openModal: boolean;
  handelLockScreen: (reason: OptionType) => void;
  onClose: () => void;
}

const CancelVisits = ({
  onClose,
  handelLockScreen,
  openModal,
}: CancelVisitsProps) => {
  const [cancelReason, setCancelReason] = useState<OptionType>({
    id: '',
    label: '',
  });
  const [reasons, setReasons] = useState<OptionType[]>([]);

  const { lookups } = useContext(LookUpContext);

  useEffect(() => {
    if (lookups === null) {
      return;
    }

    setReasons(() => {
      return lookups.cancellationReasons
        .filter((data) => data.active)
        .map((e) => {
          return { id: e.code, label: e.description };
        });
    });
  }, [lookups]);

  const handleCancelVisit = () => {
    handelLockScreen(cancelReason);
    setTimeout(() => {
      setCancelReason({ id: '', label: '' });
      onClose();
    }, 1000);
  };

  return (
    <Dialog open={openModal} fullWidth>
      <DialogTitle>
        <MediumTypography
          labelid="ProgressNote.cancelVisitModalTitle"
          defaultlabel="Cancelation Reason"
          textColor="#2A4241"
          fontSize="24px"
          fontweight={700}
        />
      </DialogTitle>
      <DialogContent>
        <Box className="pt-sm" component={'div'}>
          <DropdownComponent
            names={reasons}
            labelid="ProgressNote.cancelVisitModalDropdown"
            defaultlabelid="Select Reason"
            value={cancelReason.id}
            handleChange={(e) =>
              setCancelReason({
                id: e,
                label: reasons.find((reason) => reason.id === e)?.label || '',
              })
            }
          />
        </Box>
        <Box className="pt-lg flex__ justifyContent-FlexEnd">
          <ButtonComponent
            className="btn-primary btn-cancel alrt_Width_btn"
            variantType="contained"
            labelId="ProgressNote.Cancel"
            defaultLabelId="Cancel"
            onClick={() => {
              setCancelReason({ id: '', label: '' });
              onClose();
            }}
          />
          <ButtonComponent
            variantType="contained"
            type="submit"
            className="btn-primary btn-submit alrt_Width_btn  ml-md"
            labelId="ProgressNote.Confirm"
            defaultLabelId="Confirm"
            onClick={handleCancelVisit}
            disabled={cancelReason.id === ''}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CancelVisits;
